(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mirelia-live-activity"] && !Shopify.designMode) return;
  try {
    function randomBetween(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function initLiveActivity(el) {
    const min = Number(el.dataset.min) || 1;
    const max = Math.max(Number(el.dataset.max) || min, min);
    const countEl = el.querySelector('[data-mirelia-live-count]');

    setInterval(() => {
      countEl.textContent = randomBetween(min, max);
    }, 11000);
  }

  document.querySelectorAll('[data-mirelia-live]').forEach(initLiveActivity);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mirelia-review-carousel"] && !Shopify.designMode) return;
  try {
    function showItem(item) {
    item.style.display = 'grid';
    requestAnimationFrame(() => {
      item.style.opacity = '1';
    });
  }

  function hideItem(item) {
    item.style.opacity = '0';
    setTimeout(() => {
      item.style.display = 'none';
    }, 400);
  }

  function initReviewCarousel(root) {
    const items = Array.from(root.querySelectorAll('[data-mirelia-review-carousel-item]'));
    if (items.length < 2) return;

    let current = 0;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    setInterval(() => {
      hideItem(items[current]);
      current = (current + 1) % items.length;
      showItem(items[current]);
    }, 7000);
  }

  document.querySelectorAll('[data-mirelia-review-carousel]').forEach(initReviewCarousel);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mirelia-social-proof"] && !Shopify.designMode) return;
  try {
    function animateCount(valueEl, target) {
    const duration = 1200;
    const start = performance.now();

    function tick(now) {
      const progress = Math.min((now - start) / duration, 1);
      valueEl.textContent = Math.floor(progress * target);
      if (progress < 1) requestAnimationFrame(tick);
    }

    requestAnimationFrame(tick);
  }

  function initProofBar(bar) {
    const target = Number(bar.dataset.target) || 0;
    const valueEl = bar.querySelector('[data-mirelia-proof-value]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      valueEl.textContent = target;
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        animateCount(valueEl, target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.4 });

    observer.observe(bar);
  }

  document.querySelectorAll('[data-mirelia-proof]').forEach(initProofBar);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mirelia-urgency-timer"] && !Shopify.designMode) return;
  try {
    function formatRemaining(totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${hours}h ${minutes}m ${seconds}s`;
  }

  function initUrgencyTimer(el) {
    const durationSeconds = (Number(el.dataset.hours) * 3600) + (Number(el.dataset.minutes) * 60);
    if (durationSeconds <= 0) return;

    const valueEl = el.querySelector('[data-mirelia-urgency-value]');
    let remaining = durationSeconds;

    setInterval(() => {
      remaining = remaining > 0 ? remaining - 1 : durationSeconds;
      valueEl.textContent = formatRemaining(remaining);
    }, 1000);
  }

  document.querySelectorAll('[data-mirelia-urgency]').forEach(initUrgencyTimer);
  } catch(e) { console.error(e); }
})();

})();
